import settings from '@/settings'

const pegarPorId = (headers, data) => {
  let url = `${settings.apetrusApi}/pessoas/pegar-por-id/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const verificarPessoa = (email, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/verificaremail/?email=${email}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const pesquisarPessoa = (headers, data) => {
  let url = `${settings.apetrusApi}/pessoas/pesquisar/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const gerenciarUsuario = (headers, payload) => {
  /**
   * Método para gerenciar o usuário no PDV
   * @param {Object} headers - Headers da requisição
   * @param {Object} payload - informações da requisição, como method, parametros e body
   * @returns {Promise} - Promise da requisição
   * Métodos suportados:
   * - GET: Busca informações do usuário
   * - POST: Cria um novo usuário
   * - PUT: Atualiza informações do usuário
   * - DELETE: Deleta um usuário
   */
  let url = `${settings.apetrusApi}/pessoas/gerenciar-no-pdv/`
  const data = {
    method: payload.method,
    mode: 'cors',
    headers: headers
  }
  if (payload.parametros) {
    const keys = Object.keys(payload.parametros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload.parametros[keys[i]]}`
    }
  }
  if (payload.method === 'GET') {
    data.cache = 'default'
  } else {
    data.body = JSON.stringify(payload.body)
  }
  return fetch(url, data)
}

export default {
  pegarPorId,
  verificarPessoa,
  pesquisarPessoa,
  gerenciarUsuario
}
